var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.77 9.22C12.4 9.07 12 9.03 11.61 9.11C11.22 9.19 10.87 9.38 10.59 9.66C10.31 9.94 10.12 10.3 10.04 10.68C9.96 11.07 10 11.47 10.15 11.84C10.3 12.21 10.56 12.52 10.89 12.74C11.22 12.96 11.61 13.08 12 13.08C12.53 13.08 13.04 12.87 13.41 12.49C13.79 12.11 14 11.61 14 11.08C14 10.68 13.88 10.3 13.66 9.97C13.44 9.64 13.13 9.38 12.76 9.23L12.77 9.22Z",
    fill: "#99A1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM16.39 14.37C16.39 14.37 16.24 14.57 16.22 14.6L12 19.58L7.78 14.61L7.61 14.38C6.89 13.43 6.5 12.27 6.5 11.08C6.5 9.62 7.08 8.22 8.11 7.19C9.14 6.16 10.54 5.58 12 5.58C13.46 5.58 14.86 6.16 15.89 7.19C16.92 8.22 17.5 9.62 17.5 11.08C17.5 12.27 17.11 13.43 16.39 14.38V14.37Z",
    fill: "#99A1AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipMarker);
export default __webpack_public_path__ + "static/media/ic-chip-marker.28d1198ebad47c2eb3e288e937987dea.svg";
export { ForwardRef as ReactComponent };